"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWebVitals = void 0;
var browser_1 = require("@cian/config/browser");
var browser_2 = require("@cian/telemetry/browser");
var browser_3 = require("@cian/http-api/browser");
var browser_4 = require("@cian/logger/browser");
var attribution_1 = require("web-vitals/attribution");
function initWebVitals() {
    var config = (0, browser_1.getConfig)();
    var telemetry = (0, browser_2.getTelemetry)();
    var httpApi = (0, browser_3.getHttpApi)();
    var isEnabled = config.get('web.browser.vitals.enabled');
    if (!isEnabled) {
        return;
    }
    var transport = config.getStrict('web.browser.vitals.transport');
    var metricsPathApi = config.getStrict('web.browser.vitals.pathApi');
    var metricsMicroserviceName = config.getStrict('web.browser.vitals.microserviceName');
    var logTelemetry = config.get('web.browser.vitals.log');
    var deviceType = config.getStrict('web.deviceType');
    var microserviceName = config.getStrict('projectName');
    var url = window.location.href;
    function handler(metric) {
        var _a;
        var name = metric.name, value = metric.value, rating = metric.rating, delta = metric.delta, id = metric.id;
        var debugTarget;
        switch (metric.name) {
            case 'CLS':
                debugTarget = metric.attribution.largestShiftTarget;
                break;
            case 'FID':
            case 'INP':
                debugTarget = metric.attribution.eventTarget;
                break;
            case 'LCP':
                debugTarget = metric.attribution.element;
                break;
        }
        if (transport === 'telemetry') {
            telemetry.timer("frontend-metrics.".concat(deviceType, ".").concat(name), value);
            return;
        }
        httpApi
            .fetch({
            microserviceName: metricsMicroserviceName,
            pathApi: metricsPathApi,
            assertStatusCodes: [200, 400],
            method: 'POST',
            parameters: (_a = {
                    debugTarget: debugTarget,
                    delta: delta,
                    deviceType: deviceType,
                    id: id,
                    microserviceName: microserviceName,
                    rating: rating,
                    url: url
                },
                _a[name] = value,
                _a),
            responseType: 'json',
        })
            .then(function (res) {
            if (!logTelemetry) {
                return;
            }
            var keyPart = res.statusCode === 200 ? 'success' : 'miss';
            telemetry.increment("frontend-metrics.".concat(deviceType, ".").concat(keyPart));
        })
            .catch(function (err) {
            (0, browser_4.getLogger)().error(err);
        });
    }
    (0, attribution_1.onCLS)(handler);
    (0, attribution_1.onFCP)(handler);
    (0, attribution_1.onFID)(handler);
    (0, attribution_1.onINP)(handler);
    (0, attribution_1.onLCP)(handler);
    (0, attribution_1.onTTFB)(handler);
}
exports.initWebVitals = initWebVitals;
//# sourceMappingURL=vitals.js.map